export default __webpack_public_path__ + "static/strawberry-lemonade-26d0e1e26fc5dafbc4e19aa79fa84631.png";